import { render, staticRenderFns } from "./CarneAtivo.vue?vue&type=template&id=6e43f009&scoped=true&"
import script from "./CarneAtivo.vue?vue&type=script&lang=js&"
export * from "./CarneAtivo.vue?vue&type=script&lang=js&"
import style0 from "./CarneAtivo.vue?vue&type=style&index=0&id=6e43f009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e43f009",
  null
  
)

export default component.exports